const cards = [
  {
    title: 'Best & Affordable Education',
    desc: 'We run educational programs and schools that provide academic learning from the foundation years through higher levels.',
  },
  {
    title: 'Support for Underprivileged Families',
    desc: 'From school supplies and uniforms to nutrition support and counseling—we ensure our students have the tools to succeed.',
  },
  {
    title: 'Girls’ Education Initiatives',
    desc: 'We are especially committed to bridging the gender gap in education by supporting girls and young women in continuing their studies.',
  },
  {
    title: 'Community Development',
    desc: 'Through adult education, vocational training, and health awareness programs, we support holistic development.',
  },
  {
    title: 'Why It Matters',
    desc:  `In areas where opportunities are scarce and poverty is high, education becomes the most powerful tool
for change. At Jivan Jyoti Trust, we’ve seen how a simple classroom can transform not just a child’s
future—but the future of entire families and communities.`,
  },
];

export default function InfoCards() {
  return (
    <div className="grid md:grid-cols-3 gap-6 p-8">
      {cards.map((card, idx) => (
        <div key={idx} className="border p-4 rounded shadow hover:shadow-lg">
          <h3 className="font-semibold text-lg mb-2">{card.title}</h3>
          <p className="text-gray-600">{card.desc}</p>
          {/* <a href="#" className="text-blue-500 mt-2 inline-block">More about this →</a> */}
        </div>
      ))}
    </div>
  );
}
